/* eslint-disable */
import Api from '@/api/services/Api';

const route = '/tutor'

export default {
    get: params => {
        let customRoute = `${route}?expand=sexo,status_description&search=${params.filter}`
        switch (params.tutorEstado) {
            case "2": customRoute = `${route}?estado=1&expand=sexo,status_description&search=${params.filter}`
                break;
            case "3": customRoute = `${route}?estado=0&expand=sexo,status_description&search=${params.filter}`
                break;
            default: break;
        }
        return Api().get(customRoute, { params, crossDomain: true })
    },
    loadDetails: payload => Api().get(`${route}/${payload.id}?expand=escolaridad,sexo,status_description,foto`, { crossDomain: true }),
    getAll: () => Api().get(`${route}?estado=1`, { crossDomain: true }),
    getAllRecords: () => Api().get(`${route}?fields=id,nombre,apellido_paterno,apellido_materno&expand=status_description`, { crossDomain: true }),
    getHistory: payload => Api().get(`${route}/${payload.id}?expand=sexo,status_description,history`, { crossDomain: true }),
    post: payload => Api().post(`${route}?expand=escolaridad,sexo,status_description,foto`, payload),
    put: payload => Api().post(`${route}/${payload.get('id')}?expand=escolaridad,sexo,status_description,foto`, payload),
    delete: payload => Api().delete(`${route}/${payload.id}?expand=sexo,status_description`)
}
